import { Collapse } from 'bootstrap'

const openAccordionForHash = (hash: string) => {
  if (!hash) return
  const target = document.querySelector(hash)
  if (!target) return

  const collapseElem = target.querySelector<HTMLElement>('.accordion-collapse.collapse:not(.show)')
  if (!collapseElem) return

  const toggleButton = target.querySelector<HTMLElement>('[data-bs-toggle="collapse"]')
  if (!toggleButton) return

  toggleButton.click()

  collapseElem.addEventListener('shown.bs.collapse', () => {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, { once: true })
}

window.addEventListener('hashchange', (e) => {
  openAccordionForHash(new URL(e.newURL).hash)
})

if (window.location.hash) {
  openAccordionForHash(window.location.hash)
}

const collapseToggles = document.querySelectorAll<HTMLElement>(
  '[data-bs-toggle="collapse"]'
)

for (const toggleElem of collapseToggles) {
  const targetSelector = toggleElem.dataset.bsTarget

  const targetElem = targetSelector
    ? document.querySelector<HTMLElement>(targetSelector)
    : null

  if (!targetElem) continue

  const toggleOnHover = toggleElem.dataset.toggleOnHover === 'true'

  if (!toggleOnHover) continue

  const collapseInstance = Collapse.getOrCreateInstance(targetElem, {
    toggle: false
  })

  if (!collapseInstance) continue

  let isShowing = false
  let isActive = false
  let isFocused = false
  let isTouch = false

  const show = () => collapseInstance?.show()
  const hide = () => collapseInstance?.hide()
  const setTouch = () => {
    isTouch = true
  }
  const clearTouch = () => {
    isTouch = false
  }
  const collapse = () => {
    if (isActive) {
      isActive = false
      hide()
    }
  }
  const expand = () => {
    if (!isActive) {
      isActive = true
      show()
    }
  }

  const onLinkClick = () => {
    const targetLinkElem = document.getElementById(
      toggleElem.dataset.targetLink ?? ''
    )
    if (targetLinkElem) {
      const linkClone = targetLinkElem.cloneNode(true) as HTMLElement
      document.body.appendChild(linkClone)
      linkClone.click()
      document.body.removeChild(linkClone)
    }
  }

  targetElem.addEventListener('hide.bs.collapse', (evt) => {
    if (isActive) {
      evt.preventDefault()
    }
  })

  targetElem.addEventListener('shown.bs.collapse', () => {
    isShowing = true
    if (!isActive) {
      hide()
    }
  })

  targetElem.addEventListener('hidden.bs.collapse', () => {
    isShowing = false
    if (isActive) {
      show()
    }
  })

  toggleElem.addEventListener('click', () => {
    window.addEventListener(
      'click',
      function handle(evt) {
        window.removeEventListener('click', handle, true)
        if (!toggleElem.contains(evt.target as HTMLElement)) {
          collapse()
        }
      },
      true
    )
    expand()
  })

  toggleElem.addEventListener('touchstart', setTouch)
  toggleElem.addEventListener('touchend', clearTouch)
  toggleElem.addEventListener('touchcancel', clearTouch)

  toggleElem.addEventListener('mouseenter', () => {
    if (!isTouch) {
      isTouch = false
      expand()
    }
  })
  toggleElem.addEventListener('mouseleave', () => {
    if (!isFocused) {
      collapse()
    }
  })

  toggleElem.addEventListener('focusout', () => {
    isFocused = false
    collapse()
  })
  toggleElem.addEventListener('focusin', () => {
    isFocused = true
    expand()
  })

  toggleElem.addEventListener('keydown', (evt) => {
    if (['Enter'].includes(evt.key)) {
      evt.stopImmediatePropagation()
      onLinkClick()
    }
  })

  toggleElem.addEventListener('click', (evt) => {
    if (isShowing) {
      evt.stopImmediatePropagation()
      hide()
      onLinkClick()
    }
  })
}
